import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { PRODUCT_KEY } from "./keys";

import { ProductRepository } from "@/repositories/product";

export const useBulkDeleteProducts = () => {
  const queryClient = useQueryClient();
  const productRepository = useRef(new ProductRepository());

  return useMutation({
    mutationFn: async (ids: Array<string>) => {
      return await productRepository.current.bulkDelete(ids);
    },
    onSuccess() {
      queryClient.invalidateQueries({
        predicate(query) {
          return query.queryKey.includes(PRODUCT_KEY);
        },
      });
    },
  });
};
